// extracted by mini-css-extract-plugin
module.exports = {"timeInfo":"TimeInfo_timeInfo__q0LwP"};